<template>
  <header>
    <section>
      <div class="col1">
        <router-link to="/">
          <img src="../assets/findupix-logo-svg.svg" class="brand" />          
        </router-link>
        <ul class="inline">
          <li>
            <router-link to="/">Galerias</router-link>
          </li>
          <!-- <li>
            <router-link to="/settings">Settings</router-link>
          </li> -->
          <li><a @click="logout()">Salir</a></li>
        </ul>
      </div>
    </section>
  </header>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$store.dispatch('logout')
    }
  }
}
</script>
<style scoped>
.brand{
  width: 100px;
}
.col1{
  padding: 0.2rem 1rem;
}
header ul li a{
  padding-top: 0.8rem;
}
</style>